import { render, staticRenderFns } from "./ContextSlot.vue?vue&type=template&id=de89497e&scoped=true&"
var script = {}
import style0 from "./ContextSlot.vue?vue&type=style&index=0&id=de89497e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de89497e",
  null
  
)

export default component.exports